import type { NookDatabase } from "../infrastructure/database/database";
import { sopStateLabels } from "../domain/sop/model";
export async function sopSearchRows(db: NookDatabase) {
  const versions = new Map(
      (await db.sopTemplateVersions.toArray()).map((v) => [v.id, v]),
    ),
    templates = await db.sopTemplates.toArray(),
    drafts = (await db.sopDrafts.toArray()).filter((d) => !d.deletedAt),
    rows: {
      id: string;
      kind: string;
      title: string;
      body: string;
      path: string;
      archived: boolean;
      date: string;
      revision: number;
      draft: boolean;
    }[] = [];
  for (const t of templates) {
    if (t.deletedAt) continue;
    const v = versions.get(t.currentVersionId);
    if (!v) continue;
    const d = drafts
        .filter((d) => d.targetId === t.id && d.baseRevision === t.revision)
        .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))[0],
      fields = d?.payload ?? v;
    rows.push({
      id: t.id,
      kind: "sop-template" + (d ? " 草稿" : ""),
      title: fields.title || "未命名 SOP",
      body: [
        fields.title,
        fields.purpose,
        fields.preparation,
        ...fields.steps.map((s) =>
          [s.group, s.title, s.body, s.required ? "必做" : "选做"].join(" "),
        ),
      ].join("\n"),
      path: `/sop/templates/${t.id}${d ? "/edit?draft=" + d.id : ""}`,
      archived: !!t.archivedAt,
      date: t.updatedAt.slice(0, 10),
      revision: d?.revision ?? t.revision,
      draft: !!d,
    });
  }
  for (const d of drafts) {
    const t = templates.find((t) => t.id === d.targetId);
    if (t?.deletedAt || (t && d.baseRevision === t.revision)) continue;
    rows.push({
      id: d.id,
      kind: "sop-template 草稿" + (t ? " · 冲突分支" : ""),
      title: d.payload.title || "未命名 SOP",
      body: [
        d.payload.title,
        d.payload.purpose,
        d.payload.preparation,
        ...d.payload.steps.map((s) => [s.group, s.title, s.body].join(" ")),
      ].join("\n"),
      path: `/sop/templates/${d.targetId}/edit?draft=${d.id}`,
      archived: !!t?.archivedAt,
      date: d.updatedAt.slice(0, 10),
      revision: d.revision,
      draft: true,
    });
  }
  for (const r of await db.sopRuns.toArray()) {
    if (r.deletedAt) continue;
    const v = versions.get(r.templateVersionId);
    if (!v) continue;
    rows.push({
      id: r.id,
      kind: "sop-run",
      title: v.title,
      body: [
        v.title,
        v.purpose,
        v.preparation,
        sopStateLabels[r.state],
        r.outcomeReason,
        ...v.steps.map((s, i) =>
          [
            s.group,
            s.title,
            s.body,
            r.results[i].status,
            r.results[i].note,
            r.results[i].reason,
          ].join(" "),
        ),
      ].join("\n"),
      path: "/sop/runs/" + r.id,
      archived: !!r.archivedAt,
      date: r.createdAt.slice(0, 10),
      revision: r.revision,
      draft: false,
    });
  }
  return rows;
}
